import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { Voucher } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';
    import VoucherForm from './VoucherForm.vue';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditVoucher',
  props: {
    voucher: {},
    buttonText: {},
    title: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const queryClient = useQueryClient();

    const dimensionValues = (props.voucher as any).dimension_values || (props.voucher as any).dimensionValues;
    const initialDimensionValues: any[] = [];
    if (dimensionValues && Array.isArray(dimensionValues)) {
        dimensionValues.forEach((dimValue: any) => {
            initialDimensionValues.push(dimValue);
        });
    }

    const form = useForm({
        id: props.voucher.id,
        comment: props.voucher.comment,
        AccountHandle_Number: props.voucher.AccountHandle_Number,
        no_voucher: Number(props.voucher.no_voucher || 0),
        file: [],
        dimension_values: initialDimensionValues,
    });

    const handleError = (error: any) => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, props.voucher.company_id] });
    };

    const { hasPermission } = usePermissions();
    const updateRoute = hasPermission(Permission.VOUCHERS_OWN_UPDATE) && !hasPermission(Permission.VOUCHERS_UPDATE)
        ? 'v2.voucher.own.store'
        : 'v2.voucher.store';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route(_unref(updateRoute)),
    method: "post",
    "query-key": [_unref(QueryKey).VOUCHERS, _ctx.voucher.company_id],
    title: _ctx.title,
    "modal-size": "sm:max-w-xl",
    "button-text": _ctx.buttonText,
    onError: handleError
  }, {
    trigger: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "edit",
        size: "xs"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(t)(_ctx.buttonText)), 1),
          _createVNode(_unref(ChevronRight))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(VoucherForm, {
        voucher: _ctx.voucher,
        form: _unref(form)
      }, null, 8, ["voucher", "form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "title", "button-text"]))
}
}

})